// src/OptionSelector.js
import React from 'react';

const OptionSelector = ({ label, options, selectedValue, onChange, disabled }) => {
  // Guard: a builder passing an undefined/missing data key used to crash here on
  // options.find. Render an empty list instead of taking the page down.
  const opts = Array.isArray(options) ? options : [];
  const currentSelection = opts.find(opt => opt.id === selectedValue);

  return (
    <div className={`option-group ${disabled ? 'disabled' : ''}`}>
      <label className="option-label">
        {label}
      </label>
      
      <div className="select-wrapper">
        <select 
          className="option-select"
          value={selectedValue} 
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">-- Select Option --</option>
          {opts.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.name}{opt.price > 0 ? ` (+$${opt.price.toFixed(2)})` : ""}{opt.suffix ? `  -  ${opt.suffix}` : ""}
            </option>
          ))}
        </select>
        {/* Custom arrow for styling (handled in CSS) */}
      </div>

      {/* DESCRIPTION BOX */}
      {currentSelection && currentSelection.description && (
        <div className="option-description">
          {currentSelection.description}
        </div>
      )}
    </div>
  );
};

export default OptionSelector;